<template>
  <div>
    <EditButton :disabled="!$atividades.permissoes.includes(14)" @func="modalEditarEmpresa = true"></EditButton>
    <SideBar
      title="Editar empresa"
      @hide="cancelar"
      :disabled="!$atividades.permissoes.includes(15)"
      @excluir="excluirEmpresa"
      @status="mudarStatusEmpresa"
      :active="modalEditarEmpresa"
      :item="empresa"
      size="large"
      textSucces="Atualizar"
      @success="editarEmpresa()"
    >
      <div slot="body">
        <VuePerfectScrollbar class="scroll-editar-empresa" :settings="settings">
          <div class="w-full vs-con-loading__container" id="loadingCadastroEmpresa">
            <vs-row class="my-5" vs-type="flex" vs-align="center" vs-justify="space-between">
              <vx-card no-shadow card-border>
                <vs-row
                  vs-w="12"
                  vs-justify="flex-start"
                  vs-align="flex-start"
                  vs-type="flex"
                  class="mb-4"
                >
                  <vs-col vs-w="6" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx w-full"
                        label="Nome fantasia"
                        v-model="empresa.nome_fantasia"
                        v-validate="'required'"
                        name="nome_fantasia"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('nome_fantasia')"
                      >{{ $validators.empty }}</span>
                    </div>
                  </vs-col>
                  <vs-col vs-w="6" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx w-full"
                        label="Razão social"
                        v-model="empresa.razao_social"
                        v-validate="'required'"
                        name="razao_social"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('razao_social')"
                      >{{ $validators.empty }}</span>
                    </div>
                  </vs-col>
                  <vs-col vs-w="6" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx w-full mt-2"
                        label="CNPJ"
                        v-model="empresa.cnpj"
                        v-validate="'required|alpha_num|min:14|max:14'"
                        name="cnpj"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('cnpj')"
                      >{{ $validators.cnpj }}</span>
                    </div>
                  </vs-col>
                  <vs-col vs-w="6" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx w-full mt-2"
                        v-validate="'required'"
                        type="date"
                        name="data_fundacao"
                        label="Data de Fundação"
                        v-model="empresa.data_fundacao"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('data_fundacao')"
                      >{{ $validators.empty }}</span>
                    </div>
                  </vs-col>

                  <vs-col vs-w="6" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx w-full mt-2"
                        label="Inscrição estadual"
                        v-model="empresa.inscricao_estadual"
                        v-validate="'required|numeric'"
                        name="inscricao_estadual"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('inscricao_estadual')"
                      >{{ $validators.numeric }}</span>
                    </div>
                  </vs-col>
                  <vs-col vs-w="6" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx w-full mt-2"
                        label="Instrução municipal"
                        v-model="empresa.inscricao_municipal"
                        v-validate="'required|numeric'"
                        name="inscricao_municipal"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('inscricao_municipal')"
                      >{{ $validators.numeric }}</span>
                    </div>
                  </vs-col>
                  <vs-col vs-w="6" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <label
                        style="color: black; font-size: .85rem;"
                        class="mt-2"
                      >Regime Especial Tributação</label>
                      <br />
                      <el-select
                        filterable
                        clearable
                        name="regime"
                        class="w-full"
                        v-validate="'required'"
                        placeholder="Selecione..."
                        :popper-append-to-body="false"
                        v-model="empresa.regime_especial_tributacao"
                      >
                        <el-option
                          v-for="data in regime_especial_tributacao"
                          :value="data.id"
                          :label="data.nome"
                          :key="data.id"
                        ></el-option>
                      </el-select>
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('regime')"
                      >{{ $validators.empty }}</span>
                    </div>
                  </vs-col>
                  <vs-col vs-w="6" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx mt-2 w-full"
                        label="Senha TLS"
                        v-model="empresa.senha"
                      />
                    </div>
                  </vs-col>
                </vs-row>
              </vx-card>
            </vs-row>
            <vs-row class="my-5" vs-type="flex" vs-align="center" vs-justify="center">
              <vx-card no-shadow card-border>
                <vs-row
                  vs-w="12"
                  vs-justify="center"
                  vs-align="center"
                  vs-type="flex"
                  class="my-5 mb-4"
                >
                  <vs-col vs-w="4" class vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <label
                        style="color: black; font-size: .85rem;"
                        class="mt-2"
                      >Enquadramento Simples Nacional (opSimpNac)</label>
                      <br />
                      <el-select
                        filterable
                        name="enquadramento_simples_nacional"
                        class="w-full"
                        v-validate="'required'"
                        placeholder="Selecione..."
                        :popper-append-to-body="false"
                        v-model="empresa.optante_simples_nacional"
                      >
                        <el-option
                          v-for="data in enquadramentos_simples_nacional"
                          :value="data.id"
                          :label="data.nome"
                          :key="data.id"
                        ></el-option>
                      </el-select>
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('enquadramento_simples_nacional')"
                      >{{ $validators.empty }}</span>
                    </div>
                  </vs-col>

                  <vs-col vs-w="4" vs-type="flex" vs-align="center" vs-justify="center">
                    <vs-checkbox
                      icon-pack="feather"
                      icon="icon-check"
                      color="success"
                      v-model="empresa.incentivador_cultural"
                    >Incentivador Cultural</vs-checkbox>
                  </vs-col>
                  <vs-col vs-w="4" vs-type="flex" vs-align="center" vs-justify="center">
                    <vs-checkbox
                      icon-pack="feather"
                      icon="icon-check"
                      color="success"
                      @change="$event.type == 'change' ? changeIsenta() : ''"
                      v-model="empresa.isenta_imposto"
                    >Isenta Imposto</vs-checkbox>
                  </vs-col>
                </vs-row>
              </vx-card>
            </vs-row>
            <vs-row class="my-5" vs-type="flex" vs-align="center" vs-justify="space-between">
              <vx-card no-shadow card-border>
                <vs-row
                  vs-w="12"
                  vs-justify="flex-start"
                  vs-align="flex-start"
                  vs-type="flex"
                  class="mb-4"
                >
                  <vs-col vs-w="3" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx w-full mt-2"
                        label="CEP"
                        v-model="empresa.cep"
                        v-validate="'required|numeric|min:8|max:8'"
                        name="cep"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('cep')"
                      >{{ $validators.cep }}</span>
                    </div>
                  </vs-col>
                  <vs-col vs-w="4" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx w-full mt-2"
                        label="Municipio"
                        v-model="empresa.municipio"
                        v-validate="'required'"
                        name="municipio"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('municipio')"
                      >{{ $validators.empty }}</span>
                    </div>
                  </vs-col>
                  <vs-col vs-w="2" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx w-full mt-2"
                        label="UF"
                        v-model="empresa.uf"
                        v-validate="'required'"
                        name="uf"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('uf')"
                      >{{ $validators.empty }}</span>
                    </div>
                  </vs-col>
                  <vs-col vs-w="3" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx w-full mt-2"
                        label="Código IBGE (Município)"
                        v-model="empresa.codigo_municipio"
                        v-validate="'numeric|min:7|max:7'"
                        placeholder="Ex: 4208203"
                        name="codigo_municipio"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('codigo_municipio')"
                      >{{ $validators.empty }}</span>
                    </div>
                  </vs-col>
                  <vs-col vs-w="12" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx w-full mt-2"
                        label="Endereço"
                        v-model="empresa.endereco"
                        v-validate="'required'"
                        name="endereco"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('endereco')"
                      >{{ $validators.empty }}</span>
                    </div>
                  </vs-col>

                  <vs-col vs-w="5" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx w-full mt-2"
                        label="Telefone"
                        v-model="empresa.telefone"
                        v-validate="'required|numeric|min:8|max:11'"
                        name="telefone"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('telefone')"
                      >{{ $validators.empty }}</span>
                    </div>
                  </vs-col>
                  <vs-col vs-w="7" vs-type="flex" vs-align="center" vs-justify="center">
                    <div class="mx-2 w-full">
                      <vs-input
                        class="inputx w-full mt-2"
                        label="Website"
                        v-model="empresa.website"
                      />
                    </div>
                  </vs-col>
                </vs-row>
              </vx-card>
            </vs-row>
            <vs-row class="my-5" vs-type="flex" vs-align="center" vs-justify="space-between">
              <vs-divider class="p-0 mb-3 mt-0">
                <b>Valor dos Impostos</b>
              </vs-divider>
              <vx-card no-shadow card-border>
                <vs-row
                  vs-w="12"
                  vs-justify="flex-start"
                  vs-align="flex-start"
                  vs-type="flex"
                  class="mb-4"
                >
                  <vs-col
                    vs-w="3"
                    class="m-0"
                    vs-type="flex"
                    vs-justify="flex-start"
                    vs-align="center"
                  >
                    <vs-input
                      color="dark"
                      class="mx-2 w-full"
                      name="pis"
                      type="number"
                      min="0"
                      label="PIS"
                      icon="%"
                      icon-after="true"
                      v-model="empresa.valorPis"
                      :key="reRenderButton"
                      @change="reRenderButton += 1"
                      :disabled="empresa.isenta_imposto == 1 ? true : false"
                    ></vs-input>
                  </vs-col>
                  <vs-col
                    vs-w="3"
                    class="m-0"
                    vs-type="flex"
                    vs-justify="flex-start"
                    vs-align="center"
                  >
                    <vs-input
                      color="dark"
                      class="mx-2 w-full"
                      name="cofins"
                      type="number"
                      min="0"
                      label="COFINS"
                      icon="%"
                      icon-after="true"
                      v-model="empresa.valorCofins"
                      :key="reRenderButton"
                      @change="reRenderButton += 1"
                      :disabled="empresa.isenta_imposto == 1 ? true : false"
                    ></vs-input>
                  </vs-col>
                  <vs-col
                    vs-w="3"
                    class="m-0"
                    vs-type="flex"
                    vs-justify="flex-start"
                    vs-align="center"
                  >
                    <vs-input
                      color="dark"
                      class="mx-2 w-full"
                      name="csll"
                      type="number"
                      min="0"
                      label="CSLL"
                      icon="%"
                      icon-after="true"
                      v-model="empresa.valorCsll"
                      :key="reRenderButton"
                      @change="reRenderButton += 1"
                      :disabled="empresa.isenta_imposto == 1 ? true : false"
                    ></vs-input>
                  </vs-col>
                  <vs-col
                    vs-w="3"
                    class="m-0"
                    vs-type="flex"
                    vs-justify="flex-start"
                    vs-align="center"
                  >
                    <vs-input
                      color="dark"
                      class="mx-2 w-full"
                      name="ir"
                      type="number"
                      min="0"
                      label="IR"
                      icon="%"
                      icon-after="true"
                      v-model="empresa.valorIr"
                      :key="reRenderButton"
                      @change="reRenderButton += 1"
                      :disabled="empresa.isenta_imposto == 1 ? true : false"
                    ></vs-input>
                  </vs-col>
                  <vs-col
                    vs-w="3"
                    class="m-0"
                    vs-type="flex"
                    vs-justify="flex-start"
                    vs-align="center"
                  >
                    <vs-input
                      color="dark"
                      class="mx-2 w-full"
                      name="inss"
                      type="number"
                      min="0"
                      label="INSS"
                      icon="%"
                      icon-after="true"
                      v-model="empresa.valorInss"
                      :key="reRenderButton"
                      @change="reRenderButton += 1"
                      :disabled="empresa.isenta_imposto == 1 ? true : false"
                    ></vs-input>
                  </vs-col>
                </vs-row>
              </vx-card>
            </vs-row>
            <vs-row class="my-5" vs-type="flex" vs-align="center" vs-justify="space-between">
              <vs-divider class="p-0 mb-3 mt-0">
                <b>Configurações Fiscais NFS-e</b>
              </vs-divider>
              <vx-card no-shadow card-border>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 w-full p-2">
                  <div>
                    <vs-input
                      class="inputx w-full mt-2"
                      label="Cód. Tributação Municipal (cTribMun)"
                      placeholder="Ex: 07.13.01 ou 100 (vazio se não exigir)"
                      v-model="empresa.codigo_tributacao_municipal"
                      name="codigo_tributacao_municipal"
                    />
                    <span class="text-gray-500 text-xs mt-1 block">Deixe em branco se o município não exigir código municipal próprio.</span>
                  </div>

                  <div>
                    <vs-input
                      class="inputx w-full mt-2"
                      label="Cód. Tributação Nacional LC 116 (cTribNac)"
                      placeholder="Ex: 071301 ou 07.13.01"
                      v-model="empresa.codigo_tributacao_nacional"
                      name="codigo_tributacao_nacional"
                    />
                    <span class="text-gray-500 text-xs mt-1 block">Classificação nacional do serviço (padrão: 071301).</span>
                  </div>

                  <div>
                    <vs-input
                      class="inputx w-full mt-2"
                      label="Código NBS (cNBS)"
                      placeholder="Ex: 118032100 ou 1.1803.21.00"
                      v-model="empresa.codigo_nbs"
                      name="codigo_nbs"
                    />
                    <span class="text-gray-500 text-xs mt-1 block">Nomenclatura Brasileira de Serviços (padrão: 118032100).</span>
                  </div>

                  <div>
                    <vs-input
                      class="inputx w-full mt-2"
                      label="Série da DPS (serie_dps)"
                      placeholder="Ex: 00900 ou 70000"
                      v-model="empresa.serie_dps"
                      name="serie_dps"
                    />
                    <span class="text-gray-500 text-xs mt-1 block">Série credenciada para emissão no município/emissor nacional.</span>
                  </div>

                  <div v-if="isOptanteMeEpp" class="col-span-1 md:col-span-2">
                    <label
                      style="color: black; font-size: .85rem;"
                      class="mt-2 block"
                    >Regime de Apuração dos Tributos no SN (regApTribSN)</label>
                    <el-select
                      filterable
                      name="regime_apuracao_simples_nacional"
                      class="w-full"
                      v-validate="'required'"
                      placeholder="Selecione..."
                      :popper-append-to-body="false"
                      v-model="empresa.regime_apuracao_simples_nacional"
                    >
                      <el-option
                        v-for="data in regimes_apuracao_simples_nacional"
                        :value="data.id"
                        :label="data.nome"
                        :key="data.id"
                      ></el-option>
                    </el-select>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('regime_apuracao_simples_nacional')"
                    >{{ $validators.empty }}</span>
                    <span class="text-gray-500 text-xs mt-1 block">Obrigatório para empresa ME/EPP optante pelo Simples Nacional (evita rejeição E0166 no Sefin Nacional).</span>
                  </div>

                  <div v-if="isOptanteMeEpp" class="col-span-1 md:col-span-2">
                    <label class="vs-input--label">Tabela de Regimes Fiscais (Regime de Apuração no SN)</label>
                    <vs-table :data="regimes_apuracao_simples_nacional" class="mt-2">
                      <template slot="thead">
                        <vs-th>Código</vs-th>
                        <vs-th>Descrição</vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td :data="tr.id">{{ tr.id }}</vs-td>
                          <vs-td :data="tr.nome">{{ tr.nome }}</vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>

                  <div v-if="isOptanteMeEpp" class="col-span-1 md:col-span-2">
                    <label
                      style="color: black; font-size: .85rem;"
                      class="mt-2 block"
                    >Regime de Apuração IBS/CBS (regApIBSCBSSN)</label>
                    <el-select
                      filterable
                      name="regime_apuracao_ibscbs_simples_nacional"
                      class="w-full"
                      v-validate="'required'"
                      placeholder="Selecione..."
                      :popper-append-to-body="false"
                      v-model="empresa.regime_apuracao_ibscbs_simples_nacional"
                    >
                      <el-option
                        v-for="data in regimes_apuracao_ibscbs_simples_nacional"
                        :value="data.id"
                        :label="data.nome"
                        :key="data.id"
                      ></el-option>
                    </el-select>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('regime_apuracao_ibscbs_simples_nacional')"
                    >{{ $validators.empty }}</span>
                    <span class="text-gray-500 text-xs mt-1 block">Obrigatório para empresa ME/EPP optante pelo Simples Nacional (NT 009 §2.4 — distinto do Regime de Apuração dos Tributos acima, que é só para o ISSQN).</span>
                  </div>

                  <div v-if="isOptanteMeEpp" class="col-span-1 md:col-span-2">
                    <label
                      style="color: black; font-size: .85rem;"
                      class="mt-2 block"
                    >Código de Atividade no Simples Nacional (cAtvSN)</label>
                    <el-select
                      filterable
                      name="codigo_atividade_simples_nacional"
                      class="w-full"
                      v-validate="'required'"
                      placeholder="Selecione..."
                      :popper-append-to-body="false"
                      v-model="empresa.codigo_atividade_simples_nacional"
                    >
                      <el-option
                        v-for="data in codigos_atividade_simples_nacional"
                        :value="data.id"
                        :label="data.nome"
                        :key="data.id"
                      ></el-option>
                    </el-select>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('codigo_atividade_simples_nacional')"
                    >{{ $validators.empty }}</span>
                    <span class="text-gray-500 text-xs mt-1 block">Obrigatório para empresa ME/EPP optante pelo Simples Nacional (NT 009 §2.4, LC 123/2006). Confirme o enquadramento com o contador da empresa.</span>
                  </div>

                  <div v-if="isOptanteMeEpp" class="col-span-1 md:col-span-2">
                    <label class="vs-input--label">Tabela de Código de Atividade do Simples Nacional (LC 123/2006)</label>
                    <vs-table :data="codigos_atividade_simples_nacional" class="mt-2">
                      <template slot="thead">
                        <vs-th>Código</vs-th>
                        <vs-th>Descrição</vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td :data="tr.id">{{ tr.id }}</vs-td>
                          <vs-td :data="tr.nome">{{ tr.nome }}</vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>

                  <div class="col-span-1 md:col-span-2">
                    <label class="vs-input--label">Texto de Benefício Fiscal / Observações da Nota</label>
                    <vs-textarea
                      class="w-full mt-2"
                      placeholder="Texto legal ou observações adicionais para constar na discriminação do serviço da NFS-e (ex: mandados de segurança, isenções, etc.)."
                      v-model="empresa.texto_beneficio_fiscal"
                      name="texto_beneficio_fiscal"
                    />
                  </div>

                  <div class="col-span-1 md:col-span-2">
                    <label class="vs-input--label">Template da Descrição dos Serviços (xDescServ)</label>
                    <vs-textarea
                      class="w-full mt-2"
                      placeholder="Ex: {contrato_controle} com {contrato_garantia} meses de garantia. CONTRATO {contrato_id}. FATURA {fatura_parcela}. {forma_pagamento}. PARCELAS: {parcelas} TRIBUTOS APROXIMADOS de {tributos_aproximados}. {texto_dispensa_retencao}"
                      v-model="empresa.template_descricao_servico"
                      name="template_descricao_servico"
                    />
                    <span class="text-gray-500 text-xs mt-1 block">Template usado na discriminação do serviço da NFS-e.</span>
                  </div>

                  <div class="col-span-1 md:col-span-2">
                    <label class="vs-input--label">Template de Informações Complementares (xInfComp)</label>
                    <vs-textarea
                      class="w-full mt-2"
                      placeholder="Ex: {texto_beneficio_fiscal}"
                      v-model="empresa.template_informacoes_complementares"
                      name="template_informacoes_complementares"
                    />
                    <span class="text-gray-500 text-xs mt-1 block">Template de informações complementares enviado no envelope da DPS/NFS-e.</span>
                  </div>
                </div>

              </vx-card>
            </vs-row>
          </div>
        </VuePerfectScrollbar>
      </div>
    </SideBar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";

export default {
  name: "modalEditarEmpresa",
  props: { empresa: Object },
  data() {
    return {
      modalEditarEmpresa: false,
      error: false,
      format: "d MMMM yyyy",
      originalData: {},
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.8,
        height: 1000
      },
      reRenderButton: 0,
      regime_especial_tributacao: [
        { id: 0, nome: "0 - Nenhum" },
        { id: 1, nome: "1 - Ato Cooperado (Cooperativa)" },
        { id: 2, nome: "2 - Estimativa" },
        { id: 3, nome: "3 - Microempresa Municipal" },
        { id: 4, nome: "4 - Notário ou Registrador" },
        { id: 5, nome: "5 - Profissional Autônomo" },
        { id: 6, nome: "6 - Sociedade de Profissionais" }
      ],
      enquadramentos_simples_nacional: [
        { id: 0, nome: "Não Optante" },
        { id: 2, nome: "MEI - Microempreendedor Individual" },
        { id: 1, nome: "ME/EPP - Microempresa / Empresa de Pequeno Porte" }
      ],
      regimes_apuracao_simples_nacional: [
        {
          id: 1,
          nome: "Tributos federais e municipal pelo Simples Nacional"
        },
        {
          id: 2,
          nome: "Tributos federais pelo Simples Nacional e ISSQN por fora do SN"
        },
        {
          id: 3,
          nome: "Tributos federais e municipal por fora do Simples Nacional"
        }
      ],
      regimes_apuracao_ibscbs_simples_nacional: [
        { id: 1, nome: "IBS e CBS apurados pelo Simples Nacional" },
        { id: 2, nome: "CBS apurada pelo SN e IBS pelo regime regular" },
        { id: 3, nome: "IBS e CBS apurados pelo regime regular" }
      ],
      codigos_atividade_simples_nacional: [
        { id: "7", nome: "7 - Prestação de serviços - Anexo III" },
        { id: "8", nome: "8 - Serviços contábeis - Anexo III" },
        { id: "9", nome: "9 - Sujeitos ao Fator \"R\" - Anexo III ou V" },
        { id: "10", nome: "10 - Transporte municipal - Anexo III" },
        { id: "11", nome: "11 - Locação de bens móveis sem ISS" },
        { id: "12", nome: "12 - Construção civil (7.02/7.05) - Anexo III" },
        { id: "13", nome: "13 - Construção civil (7.02/7.05) - Anexo IV" },
        { id: "14", nome: "14 - Prestação de serviços - Anexo IV" },
        { id: "90", nome: "90 - Operações não tributadas" }
      ]
    };
  },
  computed: {
    isOptanteMeEpp() {
      return this.empresa.optante_simples_nacional == 1;
    }
  },
  watch: {
    "empresa.optante_simples_nacional"(novoValor) {
      if (novoValor != 1) {
        this.empresa.regime_apuracao_simples_nacional = null;
        this.empresa.regime_apuracao_ibscbs_simples_nacional = null;
        this.empresa.codigo_atividade_simples_nacional = null;
      }
    }
  },
  mounted() {
    // Cadastro legado permitia gravar "3" como sinônimo de ME/EPP (mesmo
    // tratamento aplicado pela API - ver empresas.optante_simples_nacional);
    // normaliza para "1" aqui para o select não renderizar em branco.
    if (this.empresa.optante_simples_nacional == 3) {
      this.empresa.optante_simples_nacional = 1;
    }
    if (this.empresa.regime_especial_tributacao == null || this.empresa.regime_especial_tributacao === undefined) {
      this.empresa.regime_especial_tributacao = 0;
    }
    this._beforeEditingCache = Object.assign({}, this.empresa);
    this.originalData = this.empresa;
  },
  methods: {
    async submitForm() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.error = true;
          this.$vs.notify(this.$notify.Empty);
          return;
        }
        if (!this.validarEnquadramentoSimplesNacional()) {
          this.error = true;
          return;
        }
        this.editarEmpresa();
      });
    },
    validarEnquadramentoSimplesNacional() {
      if (this.isOptanteMeEpp && !this.empresa.regime_apuracao_simples_nacional) {
        this.$vs.notify(
          this.$notify.Custom(
            "Regime de Apuração obrigatório",
            "Empresa optante pelo Simples Nacional como ME/EPP exige o Regime de Apuração dos Tributos (regApTribSN). Selecione uma opção em Configurações Fiscais NFS-e antes de salvar.",
            "danger"
          )
        );
        return false;
      }
      if (this.isOptanteMeEpp && !this.empresa.regime_apuracao_ibscbs_simples_nacional) {
        this.$vs.notify(
          this.$notify.Custom(
            "Regime de Apuração de IBS/CBS obrigatório",
            "Empresa optante pelo Simples Nacional como ME/EPP exige o Regime de Apuração de IBS/CBS (regApIBSCBSSN). Selecione uma opção em Configurações Fiscais NFS-e antes de salvar.",
            "danger"
          )
        );
        return false;
      }
      if (this.isOptanteMeEpp && !this.empresa.codigo_atividade_simples_nacional) {
        this.$vs.notify(
          this.$notify.Custom(
            "Código de Atividade do Simples Nacional obrigatório",
            "Empresa optante pelo Simples Nacional como ME/EPP exige o Código de Atividade do Simples Nacional (cAtvSN). Selecione uma opção em Configurações Fiscais NFS-e antes de salvar.",
            "danger"
          )
        );
        return false;
      }
      return true;
    },
    async editarEmpresa() {
      this.$vs.loading();
      try {
        const res = await this.$http.put(
          `empresa/${this.empresa.id}`,
          this.empresa
        );
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Edição da empresa N°" + res.id
        };
        await this.$logger(logData);
        this.$vs.notify(this.$notify.Success);
        this.modalEditarEmpresa = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      } finally {
        this.$vs.loading.close();
      }
    },
    async excluirEmpresa() {
      this.$vs.loading();
      try {
        await this.$http.delete(`empresa/${this.empresa.id}`);
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "excluir",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Exlusão da empresa N°" + this.empresa.id
        };
        await this.$logger(logData);
        this.$vs.notify(this.$notify.Success);
        this.modalEditarFornecedor = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      } finally {
        this.$vs.loading.close();
        this.$emit("update");
      }
    },
    async mudarStatusEmpresa() {
      this.$vs.loading();
      try {
        const res = await this.$http.put(`empresa/${this.empresa.id}`, {
          lixeira: !this.empresa.lixeira
        });
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Mudança do status da empresa N°" + res.id
        };
        await this.$logger(logData);
        this.$vs.notify(this.$notify.Success);
        this.modalEditarFornecedor = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      } finally {
        this.$vs.loading.close();
        this.$emit("update");
      }
    },
    cancelar() {
      Object.assign(this.empresa, this._beforeEditingCache);
      this.originalData = this._beforeEditingCache = null;
      this.modalEditarEmpresa = false;
    },
    async changeIsenta() {
      if (this.empresa.isenta_imposto == true) {
        this.empresa.valorCofins = 0;
        this.empresa.valorPis = 0;
        this.empresa.valorInss = 0;
        this.empresa.valorIr = 0;
        this.empresa.valorCsll = 0;
      }
      this.reRenderButton += 1;
    }
  },
  components: { ...components }
};
</script>

<style>
.scroll-editar-empresa {
  height: 75vh !important;
}
</style>
